var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h2',[_vm._v("Projects")]),_c('alert',{ref:"alert"}),_c('projects-view',{attrs:{"projects":_vm.projects},on:{"fillModal":_vm.fillProjectForm,"deleteProject":_vm.deleteProjects}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }